import { WprBaseConverter } from '../WprBaseConverter';

/**
 * 性別コンバータ
 */
export class WprGenderConverter extends WprBaseConverter {
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('性別');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 値変換処理
	 * @param value 値
	 * @returns 変換後の値
	 */
	public convert(value: any): string {
		if (value === 'M')
			return '男性';
		if (value === 'F')
			return '女性';
		return '';
	}
	// --------------------------------------------------------------------------
}
